import type { FlexProps } from '@chakra-ui/react';
import { Flex, Text } from '@chakra-ui/react';
import Info from '@ui/components/Info/Info';
import { useTranslations } from '@ui/i18n';
import type { LiquidityStrategyDepositToken } from '@ui/utils/strategy';
import {
  LiquidityStrategyTokenDict,
  useVaultExchangeRate,
} from '@ui/utils/strategy';

export const ReceiveRows = ({
  isWithdraw,
  amountStr,
  token,
  ...props
}: FlexProps & {
  isWithdraw: boolean;
  amountStr: string;
  token: LiquidityStrategyDepositToken;
}) => {
  const t = useTranslations();

  const tokenInfo = LiquidityStrategyTokenDict[token];
  const exchangeRateRet = useVaultExchangeRate(token);
  const receivedAmountFromDeposit = exchangeRateRet.data
    ? (Number(amountStr) / exchangeRateRet.data).toFixed(2)
    : null;
  const receivedAmountFromWithdraw = Number(amountStr).toFixed(2);

  return (
    <>
      <Info
        title={t('You will receive')}
        value={
          isWithdraw ? (
            receivedAmountFromWithdraw &&
            !Number.isNaN(receivedAmountFromWithdraw) ? (
              <Flex alignItems="center">
                <Text>{receivedAmountFromWithdraw}</Text>
                <tokenInfo.Icon />
              </Flex>
            ) : (
              '--'
            )
          ) : receivedAmountFromDeposit &&
            !Number.isNaN(receivedAmountFromDeposit) ? (
            `${receivedAmountFromDeposit} ${tokenInfo.vaultTokenName}`
          ) : (
            '--'
          )
        }
        {...props}
      />
      <Info
        title={t('Exchange rate')}
        value={`1 ${tokenInfo.name} : ${
          exchangeRateRet.data ? (1 / exchangeRateRet.data).toFixed(4) : '--'
        } ${tokenInfo.vaultTokenName}`}
        mt="16px"
      />
    </>
  );
};
